// eslint-disable-next-line no-shadow
export enum GenerateResult {
	SUCCESS = 'success',
	FAIL = 'fail',
}
